import React from "react"
import classes from "./FormWrapper.module.scss"
import classNames from "classnames"

const FormWrapper = ({ children, size }) => {
  return <div className={classNames(classes.wrapper, { [classes[size]]: size })}>{children}</div>;
};

export default FormWrapper;
